import { render, staticRenderFns } from "./Oneclickwriting.vue?vue&type=template&id=fbd160ac&scoped=true&"
import script from "./Oneclickwriting.vue?vue&type=script&lang=js&"
export * from "./Oneclickwriting.vue?vue&type=script&lang=js&"
import style0 from "./Oneclickwriting.vue?vue&type=style&index=0&id=fbd160ac&lang=scss&scoped=true&"
import style1 from "./Oneclickwriting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd160ac",
  null
  
)

export default component.exports